<template>
  <!-- owner and co owners -->
  <div v-if="component_record" class="flex flex-col h-full transition duration-side-menu-transition-duration">
    <!-- co owners -->

    <div class="h-full bg-white dark:bg-dark-box-background">
      <div class="h-full">
        <div class="text-sm sm:text-base font-[16px] px-1 mb-4 flex align-center items-center place-content-center justify-between">
          <div class="pl-0 text-2xl font-medium capitalize dark:text-white">
            {{ component_record.type }} {{ $t("Owners") }}
          </div>

          <Menu as="div" class="relative flex-shrink-0 top-1">
            <MenuButton
              class="inline-flex items-center justify-center w-5 h-5 text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
              <EllipsisVertical class="w-5 h-5" aria-hidden="true" />
            </MenuButton>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0">
              <MenuItems
                class="absolute z-50 mx-3 -ml-[160px] whitespace-nowrap origin-bottom-right dark:bg-dark-screen-background w-48 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <MenuItem v-slot="{ active }" @click.prevent="$emitter.emit(ALL_EMITTERS.CREATE_OWNER, { record: component_record })">
                  <div
                    :class="[
                      active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                      'group flex items-center px-3 py-2 text-sm cursor-pointer'
                    ]">
                    <ShieldEllipsis class="w-5 h-5 mr-4" aria-hidden="true" />
                    <span>{{ $t("Change Owner") }}</span>
                  </div>
                </MenuItem>
                <MenuItem v-slot="{ active }" @click.prevent="handleEditClick()">
                  <div
                    :class="[
                      active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                      'group flex items-center px-3 py-2 text-sm cursor-pointer'
                    ]">
                    <Handshake class="w-5 h-5 mr-4" aria-hidden="true" />
                    <span>{{ $t("Change Co-owners") }}</span>
                  </div>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div class="h-[calc(100%-36px)] overflow-auto">
          <dd class="mt-4 text-sm text-gray-900 sm:text-base sm:mt-0 sm:col-span-2">
            <div class="flex-shrink-0 block mt-0 ml-2 group">
              <div v-if="component_record?.owner" class="flex items-center mt-4">
                <img
                  v-if="Record.from($store.state.data.users.find((u) => u.id == component_record?.owner))?.avatar"
                  class="inline-block w-9 h-9 rounded-full object-cover"
                  onerror="this.onerror=null; this.src=window.default_avatar;"
                  :src="Record.from($store.state.data.users.find((u) => u.id == component_record?.owner)).avatar"
                  alt="">
                <Avatar
                  v-else
                  :radius="40"
                  class="inline-block rounded-full"
                  :first-name="Record.from($store.state.data.users.find((u) => u.id == component_record?.owner)).first_name"
                  :last-name="Record.from($store.state.data.users.find((u) => u.id == component_record?.owner)).last_name" />
                <div class="mx-3">
                  <p class="!text-lg font-medium text-gray-700 dark:text-white sm:text-base">
                    {{ Record.from($store.state.data.users.find((u) => u.id == component_record?.owner))?.full_name
                    }}<span class="font-normal">{{
                      $store.state.data.users.find((u) => u.id == component_record?.owner)?.job_title
                        ? `, ${$store.state.data.users.find((u) => u.id == component_record?.owner)?.job_title}`
                        : ""
                    }}</span>
                  </p>
                  <span class="text-common-grey !text-md">{{ $t("Owner") }}</span>
                </div>
              </div>
            </div>
          </dd>

          <div v-if="component_record.co_owners?.length">
            <dd
              v-for="co_owner in component_record.co_owners"
              :key="co_owner.id"
              class="mt-1 text-sm text-gray-900 sm:text-base sm:mt-0 sm:col-span-2">
              <div class="flex items-center justify-between w-full">
                <div class="flex items-center mt-4 ml-2">
                  <img
                    v-if="$store.state.data.users.filter((user) => user.id == co_owner)[0]?.avatar"
                    class="inline-block w-9 h-9 rounded-full object-cover"
                    onerror="this.onerror=null; this.src=window.default_avatar;"
                    :src="$store.state.data.users.filter((user) => user.id == co_owner)[0]?.avatar"
                    alt="">
                  <Avatar
                    v-else
                    :radius="40"
                    class="inline-block rounded-full"
                    :first-name="$store.state.data.users.filter((user) => user.id == co_owner)[0].first_name"
                    :last-name="$store.state.data.users.filter((user) => user.id == co_owner)[0].last_name" />
                  <div class="ml-3">
                    <p class="!text-lg font-medium sm:text-base dark:text-white">
                      {{ $store.state.data.users.filter((user) => user.id == co_owner)[0].first_name }}
                      {{ $store.state.data.users.filter((user) => user.id == co_owner)[0].last_name
                      }}<span class="font-normal">{{
                        $store.state.data.users.filter((user) => user.id == co_owner)[0]?.job_title
                          ? `, ${$store.state.data.users.filter((user) => user.id == co_owner)[0]?.job_title}`
                          : ""
                      }}</span>
                    </p>
                    <div class="flex items-center justify-between w-full pr-2 !text-md text-common-grey">
                      <div>{{ $t("Co-Owner") }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Record } from "@/models/record"
import Avatar from "@/components/shared/Avatar.vue"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { EllipsisVertical, Handshake, ShieldEllipsis } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"

export default {
  components: { Avatar, Menu, MenuButton, MenuItem, MenuItems, EllipsisVertical, ShieldEllipsis, Handshake },
  props: {
    linkedRecord: {
      type: String,
      default: null
    },
    connectTo: {
      type: String,
      default: null
    }
  },
  emits: [],
  data() {
    return {
      ALL_EMITTERS,
      Record,
      component_record: null,
      loading: false,
      record_error: false
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(this.$props)
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
  },

  methods: {
    handleEditClick() {
      this.$emitter.emit(ALL_EMITTERS.CHANGE_CO_OWNERS, { record: this.component_record })
    }
  }
}
</script>
